import { IBasicPickerValue } from 'components/foundation/pickers/basic-picker/BasicPicker/BasicPicker';
import { t } from 'i18next';
import { castArray, sortBy } from 'lodash';
import { useMemo } from 'react';
import { TPermissions } from 'utils/positionUtils';
import useManageablePermissions from './useManageablePermissions';

export const POSITION_ANY_ID = 'any';

export default function usePositionPickerOptions(
  permissions?: TPermissions | TPermissions[],
  includeAnyPosition?: boolean
) {
  const { getManageablePermissions, error } = useManageablePermissions();
  const options: IBasicPickerValue[] = useMemo(() => {
    const permissionArray = permissions ? castArray(permissions) : undefined;
    const positions = getManageablePermissions(permissionArray);
    const mapped = positions.map((position) => ({ id: position.id, name: position.title }));

    if (includeAnyPosition) {
      mapped.unshift({ id: POSITION_ANY_ID, name: t('Any Position') });
    }

    return sortBy(mapped, 'title');
  }, [getManageablePermissions, permissions, includeAnyPosition]);

  return { data: options, error: error ? true : false };
}
